export const formatPriceWithReduction = (
  currentPrice: number,
  originalPrice?: number
): { price: string; showReduction: boolean; reductionText?: string } => {
  const formattedPrice = new Intl.NumberFormat("sv-SE", {
    style: "currency",
    currency: "SEK",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(currentPrice);

  if (originalPrice && currentPrice < originalPrice) {
    const reduction = originalPrice - currentPrice;
    // Format as number with spaces, then add "kr" - e.g., "30 000 kr"
    const formattedReduction = new Intl.NumberFormat("sv-SE", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(reduction);
    return {
      price: formattedPrice,
      showReduction: true,
      reductionText: `-${formattedReduction} kr`
    };
  }

  return { price: formattedPrice, showReduction: false };
};
